import { render, staticRenderFns } from "./ClientesCadastro.vue?vue&type=template&id=480a6a3c&scoped=true&"
import script from "./ClientesCadastro.vue?vue&type=script&lang=js&"
export * from "./ClientesCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ClientesCadastro.vue?vue&type=style&index=0&id=480a6a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a6a3c",
  null
  
)

export default component.exports